import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getSqlScripts() {
  const data = await apiGet('helper/sqlScripts/');
  useHelperStore().setSqlScripts(data);
}
